// Mock data for Life Care and Wellness
// This will be replaced with backend integration later

export const contactInfo = {
  phone: "1300 404 229",
  email: "admin@lifecarewellness.au",
  address: "Logan & Brisbane, Queensland"
};

export const services = [
  {
    id: 1,
    title: "Support Coordination",
    description: "Support Coordination is designed to support participants to make the most of their NDIS plans. Types of Support Coordination we provide:",
    points: [
      "Level 1: Support Connection",
      "Level 2: Coordination of Supports",
      "Level 3: Specialist Support Coordination"
    ]
  },
  {
    id: 2,
    title: "SLES",
    description: "Our School Leaver Employment Support program is designed to equip young adults with disabilities with the skills and confidence they need to successfully navigate the transition from school to employment.",
    points: []
  },
  {
    id: 3,
    title: "Counselling Services",
    description: "Professional counselling services tailored to your needs:",
    points: [
      "Women's Counselling",
      "Children and Adolescent Counselling",
      "Men's Counselling",
      "Prison and Youth Justice Counselling"
    ]
  },
  {
    id: 4,
    title: "Independent Living Options",
    description: "Our ILO support service empowers NDIS participants to create and live their desired lifestyle.",
    points: [
      "Our ILO support packages comprise primary and supplementary supports",
      "Regular monitoring is crucial to the success of your ILO"
    ]
  },
  {
    id: 5,
    title: "Personal Training",
    description: "Our personalised training programs empower NDIS participants to achieve their fitness goals and improve overall wellbeing. Our qualified trainers work closely with individuals to develop tailored exercise plans that cater to their specific needs, abilities, and aspirations.",
    points: []
  },
  {
    id: 6,
    title: "NDIS Consulting",
    description: "We offer comprehensive support, from the initial stages of business setup to ongoing operations.",
    points: [
      "Start-up Guidance",
      "Ongoing Support",
      "Industry Expertise",
      "Process Optimisation"
    ]
  },
  {
    id: 7,
    title: "Assistance with Daily Life",
    description: "Our Assistance with Daily Life services provide essential support in managing everyday tasks and activities, enhancing your ability to live independently and confidently.",
    points: []
  },
  {
    id: 8,
    title: "Multilingual Services",
    description: "We understand the importance of communication and cultural sensitivity. Our multilingual services ensure that language barriers are never an obstacle to accessing our support. We offer services in a variety of languages, allowing us to connect with individuals from diverse backgrounds and cultures.",
    points: []
  },
  {
    id: 9,
    title: "Assistive Technology",
    description: "We recognize the transformative power of AT in enabling individuals with disabilities to overcome challenges and enhance their daily lives.",
    points: []
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Your NDIS Plan: A Complete Guide",
    excerpt: "Navigate your NDIS plan with confidence. Learn about plan management, budgeting, and making the most of your supports.",
    date: "March 15, 2025",
    category: "NDIS Support",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80"
  },
  {
    id: 2,
    title: "The Importance of Support Coordination in Your NDIS Journey",
    excerpt: "Discover how support coordination can help you achieve your goals and connect with the right services.",
    date: "March 10, 2025",
    category: "Support Services",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=800&q=80"
  },
  {
    id: 3,
    title: "Building Independence: Tips for NDIS Participants",
    excerpt: "Practical strategies and insights to help you build skills and increase your independence with NDIS support.",
    date: "March 5, 2025",
    category: "Independent Living",
    image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&q=80"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Logan",
    text: "Life Care and Wellness has transformed my life. Their support coordinators are compassionate, professional, and truly understand my needs.",
    rating: 5
  },
  {
    id: 2,
    name: "James K.",
    location: "Brisbane",
    text: "The team's dedication to helping me achieve my goals has been incredible. I feel empowered and supported every step of the way.",
    rating: 5
  },
  {
    id: 3,
    name: "Maria L.",
    location: "Logan",
    text: "Outstanding service! They took the time to understand my cultural background and provided support in my language. Highly recommended.",
    rating: 5
  }
];

// Mock function to simulate contact form submission
export const submitContactForm = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log("Form submitted (mock):", formData);
  
  // Return success
  return {
    success: true,
    message: "Thank you for contacting us! We'll get back to you within 24 hours."
  };
};
